module.exports = __webpack_public_path__ + "media/25.a8aeae97.mp3";